export default {
  items: state => state.items,
  products: state => state.products
};